<template>
  <q-td :props="props">
    <span v-if="ruleName" class="row items-center no-wrap">
      {{ ruleName }}
      <q-icon
        v-if="criteriaLines.length"
        name="mdi-information-outline"
        size="1.2em"
        class="q-ml-xs cursor-pointer"
      >
        <q-tooltip anchor="top middle" self="bottom middle" max-width="420px">
          <div v-for="(line, index) in criteriaLines" :key="index">{{ line }}</div>
        </q-tooltip>
      </q-icon>
    </span>
  </q-td>
</template>

<script>
import { commissionRuleCriteriaTooltip } from '../../utils/commissionRule';

export default {
  name: 'CommissionRuleCell',
  props: {
    props: {
      type: Object,
      required: true
    }
  },
  computed: {
    ruleName() {
      return this.props.row.comission_rule_name || '';
    },
    criteriaLines() {
      return commissionRuleCriteriaTooltip(this.props.row.comission_rule_criteria, (key) => this.$t(key));
    }
  }
};
</script>
